<template>
  <select
    class="form-control"
    :value="value"
    @input="$emit('input', $event.target.value)"
  >
    <option v-if="showOptionEmpty" value="">Nenhum</option>
    <option v-for="(item, index) in options" :key="index" :value="item.value">
      {{ item.label }}
    </option>
  </select>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: null,
      required: true
    },
    options: {
      type: Array
    },
    showOptionEmpty: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Select.vue